import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { TaxBehaviorEnum as n } from "../../../../libs/types/dist/index8.mjs";
import { useTranslation as l, FieldLabel as u, centsToUnits as x } from "@systemeio/ui";
import { twJoin as d } from "tailwind-merge";
import { CurrencyBadge as f } from "../../../../ui-kit/currency-badge.mjs";
import { getAmountWithCurrencySymbol as i } from "../../../../utils/get-amount-with-currency-symbol.mjs";
import { useOfferStore as p } from "../../../../store/index.mjs";
import { PriceBreakdown as h } from "./price-breakdown.mjs";
import { useLocaleContext as y } from "../../../../providers/use-locale-provider.mjs";
const S = ({
  calculatePrice: t,
  isLoading: c,
  pricePlan: e
}) => {
  const { t: m } = l(), { locale: a } = y(), { finalAmount: s } = p();
  return /* @__PURE__ */ o("div", { className: d("flex flex-col gap-1", c && "animate-pulse"), children: [
    /* @__PURE__ */ r(u, { label: m("public_pages_purchase.order_summary") }),
    /* @__PURE__ */ o("div", { className: "border-text-secondary/30 flex flex-col gap-5 rounded-lg border px-3.5 py-5", children: [
      (e == null ? void 0 : e.taxBehavior) === n.Exclusive && t && /* @__PURE__ */ r(
        h,
        {
          finalAmount: s,
          calculatePrice: t,
          currency: e.currency
        }
      ),
      s && s > 0 && /* @__PURE__ */ o("div", { className: "flex w-full items-center justify-between", children: [
        /* @__PURE__ */ r("span", { className: "text-[14px] font-bold", children: m("public_pages_purchase.total") }),
        /* @__PURE__ */ o("div", { className: "flex flex-col items-center gap-1.5", children: [
          /* @__PURE__ */ o("div", { className: "flex items-center gap-2.5", children: [
            /* @__PURE__ */ r(f, { currency: e.currency }),
            /* @__PURE__ */ r("span", { className: "text-[14px] font-bold", children: i(
              x(s),
              e.currency,
              a
            ) })
          ] }),
          (e == null ? void 0 : e.taxBehavior) === n.Inclusive && t && t.tax.rate > 0 && /* @__PURE__ */ r("span", { className: "text-text-tertiary text-xs", children: m("public_pages_purchase.including_tax", {
            percent: t.tax.rate,
            amount: i(
              x(t.tax.amount),
              e.currency,
              a
            )
          }) })
        ] })
      ] })
    ] })
  ] });
};
export {
  S as DigitalOrderSummary
};
